import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faEdit,
  faEnvelope,
  faMobile,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { Button, Card, Form, Table } from "@themesberg/react-bootstrap";
import {
  confirmDeleteToast,
  confirmRequestToast,
  sendError,
  sendSuccess,
  status,
} from "../helpers/Helper";
import { Model } from "../components/Model";
import { Textbox } from "../components/Textbox";
import { SelectBox } from "../components/SelectBox";
import { API_URL_ENDPOINT } from "../appsetting";
import TextEditor from "../components/TextEditor";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useApi } from "../helpers/useApi";
import { Avatar } from "@mui/material";
import { faRefresh, faClose } from "@fortawesome/free-solid-svg-icons";
import DropzoneUpload from "../components/DropzoneUpload";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import OffCanvas from "../components/OffCanvas";
import LoadAlert from "../components/LoadAlert";
import Bilty from "../components/Bilty";
import { Routess } from "../Routes/routes";
import { faInternetExplorer } from "@fortawesome/free-brands-svg-icons";
import CustomPagination from "../components/CustomPagination";
import SignatureUploader from "../components/SignatureUploader";

export const CompanyDetail = () => {
  const callApi = useApi();
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [trasnsporterRequest, setTransporterRequest] = useState([]);
  const methods = useForm();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
    watch,
    setValue,
  } = methods;

  const isMinPlus = watch("isMinPlus");

  const [searchTerm, setSearchTerm] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  const [dataLoading, setDataLoading] = useState(false);
  const [brachLoading, setBranchLoading] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [showCompanyEditModel, setShowCompanyEditModel] = useState(false);

  const [branches, setBranches] = useState({
    items: [],
    pageNo: 1,
    pageSize: 10,
    totalPage: 0,
    totalRecords: 0,
  });

  const [states, setStates] = useState({
    items: [],
    pageNo: 1,
    pageSize: 50,
    totalPage: 0,
    totalRecords: 0,
  });

  const [city, setCity] = useState({
    items: [],
    pageNo: 1,
    pageSize: 50,
    totalPage: 0,
    totalRecords: 0,
  });

  useEffect(() => {
    getData();
    getBranches();
    loadStates();
  }, []);


  useEffect(()=>{
    reset({
      companyName:data?.companyName,
      jurisdiction:data?.jurisdiction || "",
      regNumber:data?.transportRegNumber || "",
      mobile:data?.mobile || "",
      email:data?.email || "",
      website:data?.website || "",
      bankName:data?.bankName || "",
      accountHolderName:data?.accountHolderName || "",
      accountNumber:data?.accountNumber || "",
      ifsc:data?.ifsc || ""
    })
  },[data])

  const getData = async () => {
    try {
      setDataLoading(true);
      const response = await callApi(API_URL_ENDPOINT.Company + `/${id}`);
      if (response.status) {
        if (response?.data == null) {
          goBack();
          return;
        }
        setData(response?.data ?? {});
      } else {
        throw new Error(response.message);
      }
    } catch {
      setData({});
      goBack();
    } finally {
      setDataLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    getBranches(newPage);
  };

  const handleView = (id) => {
    alert("Not Set");
    // navigate(Routess.Company.path + `/${id}`)
  };

  const getBranches = async (cp = null) => {
    try {
      setBranchLoading(true);
      const filters = [];
      if (searchTerm) filters.push(`SearchText:${searchTerm}`);
      if (id) {
        filters.push(`CompanyID:${id}`);
      } else {
        return;
      }
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${cp ?? branches.pageNo}`,
        `pageSize=${branches.pageSize}`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        API_URL_ENDPOINT.Company + `/branch?${queryParams}`
      );
      if (response.status) {
        setBranches(response.data);
      }
    } catch {
      // setStates([]);
    } finally {
      setBranchLoading(false);
    }
  };

  const loadStates = async () => {
    try {
      const filters = [];
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${states.pageNo}`,
        `pageSize=${states.pageSize}`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        API_URL_ENDPOINT.States + `?${queryParams}`
      );
      if (response.status) {
        setStates(response.data);
      }
    } catch {
      // setStates([]);
    } finally {
      setDataLoading(false);
    }
  };

  const getCities = async (stateid) => {
    try {
      //clear existing city
      setCity({
        items: [],
        pageNo: 1,
        pageSize: 50,
        totalPage: 0,
        totalRecords: 0,
      });
      const filters = [];
      if (stateid) filters.push(`StateID:${stateid}`);
      const queryParams = [
        filters.length ? `filters=${filters.join(",")}` : null,
        `pageNo=${city.pageNo}`,
        `pageSize=${city.pageSize}`,
        `sortOrder=desc`,
      ]
        .filter(Boolean)
        .join("&");

      const response = await callApi(
        API_URL_ENDPOINT.Cities + `?${queryParams}`
      );
      if (response.status) {
        setCity(response.data);
      }
    } catch {
      // setStates([]);
    } finally {
      // setDataLoading(false);
    }
  };

  const updateCompany = async (data) => {
    try{
    // console.log("DATA", data)
    const payload ={
      "id": id,
      "companyName": data.companyName,
      "jurisdiction": data.jurisdiction,
      "transportRegNumber": data.regNumber,
      "email": data.email,
      "mobile": data.mobile,
      "website": data.website,
      "bankName": data.bankName || null,
      "accountNumber": data.accountNumber || null,
      "accountHolderName": data.accountHolderName || null,
      "ifsc": data.ifsc || null
    }
      const response = await callApi(API_URL_ENDPOINT.Company, {
        method: "PUT",
        data: payload,
      });
      if (response.status) {
        setShowCompanyEditModel(false);
        reset();
        getData();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  }

  const onFormSubmit = async (data) => {
    try {
      const payload = {
        companyID: parseInt(id, 10) || 0,
        branchTitle: data.branchTitle || "",
        branchCode: data.branchCode,
        address: data.address || "",
        cityID: parseInt(data.cityID, 10) || 0,
        stateID: parseInt(data.stateID, 10) || 0,
        firstName: data.firstName,
        lastName: data.lastName,
        userEmail: data.useremail,
        userPhone: data.userMobile,
      };

      const response = await callApi(API_URL_ENDPOINT.Company + "/branch", {
        method: "POST",
        data: payload,
      });
      if (response.status) {
        setShowModel(false);
        reset();
        getBranches();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  
  const saveSignToDB = async (key) => {
      try {
      const response = await callApi(API_URL_ENDPOINT.Company + `/upload-sign?key=${key}&companyID=${id}`, {
          method: "POST",
          data: null
      });
      if (response.status) {
          sendSuccess(response.message)
          getData()
      } else {
          throw Error(response.message || "Something Went Wrong");
      }
      } catch (ex) {
      sendError(ex.message);
      }
  };
  

  const deleteType = async () => {
    try {
      const response = await callApi(API_URL_ENDPOINT.Truck + "/types/" + id, {
        method: "DELETE",
        data: null,
      });
      if (response.status) {
        goBack();
        sendSuccess(response.message);
      } else {
        throw Error(response.message || "Something Went Wrong");
      }
    } catch (ex) {
      sendError(ex.message);
    }
  };

  const goBack = () => {
    navigate(Routess.Company.path);
  };
  return (
    <>
      <Model show={showCompanyEditModel} size={"lg"}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Update Company Details</h5>
          <Button
            variant=""
            style={{ width: 30, height: 30, outline: "none" }}
            className="btn-sm rounded-circle"
            onClick={() => setShowCompanyEditModel(false)}
          >
            <FontAwesomeIcon icon={faClose} />
          </Button>
        </div>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(updateCompany)}>
            <div className="row">
              <div className="col-md-4">
                <Form.Group className="mb-2">
                  <Textbox
                    Label="Company Name"
                    Placeholder="Company Name"
                    name={"companyName"}
                    validationRules={{ required: "Company Name is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-2">
                  <Textbox
                    Label="Reg. Number"
                    Placeholder="Reg. Number"
                    name={"regNumber"}
                    validationRules=""
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-2">
                  <Textbox
                    Label="Jurisdiction"
                    Placeholder="Jurisdiction"
                    name={"jurisdiction"}
                    validationRules={{ required: "Jurisdiction is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Website"
                    name={"website"}
                    Placeholder="Website"
                    validationRules=""
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Email"
                    name={"email"}
                    Placeholder="Email"
                    validationRules=""
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-4">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Mobile Number"
                    name={"mobile"}
                    Placeholder="Mobile"
                    validationRules={{
                      required: "Mobile Number is required",
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <h6>Bank Details</h6>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Bank Name"
                    name={"bankName"}
                    Placeholder="Bank Name"
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Account Number"
                    name={"accountNumber"}
                    Placeholder="A/C Number"
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Account Holder Name"
                    name={"accountHolderName"}
                    Placeholder="A/c Holder Name"
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="IFS Code"
                    name={"ifsc"}
                    Placeholder="IFS Code"
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="text-end">
              <Button
                type="Button"
                className="me-2"
                variant="outline-danger"
                onClick={() => setShowCompanyEditModel(false)}
              >
                Close
              </Button>
              <Button
                type="submit"
                className=""
                disabled={isSubmitting}
                variant="success"
              >
                Save Changes
              </Button>
            </div>
          </Form>
        </FormProvider>
      </Model>

      {/* Add Passing Ton Model */}
      <Model show={showModel} size={"lg"}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Add Company Branch</h5>
          <Button
            variant=""
            style={{ width: 30, height: 30, outline: "none" }}
            className="btn-sm rounded-circle"
            onClick={() => setShowModel(false)}
          >
            <FontAwesomeIcon icon={faClose} />
          </Button>
        </div>
        <FormProvider {...methods}>
          <Form onSubmit={handleSubmit(onFormSubmit)}>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-2">
                  <Textbox
                    Label="Branch Name"
                    Placeholder="Branch Name"
                    name={"branchTitle"}
                    validationRules={{ required: "Name is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-2">
                  <Textbox
                    Label="Branch Code"
                    Placeholder="Branch Code"
                    name={"branchCode"}
                    validationRules={{
                      required: "Code is required",
                      pattern: {
                        value: /^[A-Z]{3,4}$/,
                        message:
                          "Branch Code must be 3 or 4 uppercase letters only",
                      },
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-2">
                  <Textbox
                    Label="Address"
                    Placeholder="Address"
                    name={"address"}
                    validationRules={{ required: "Address is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <SelectBox
                    Label="State"
                    name={"stateID"}
                    validationRules={{ required: "State is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                    onChange={(e) => getCities(e.target.value)}
                  >
                    <option value={""} selected>
                      Select State
                    </option>
                    {states?.items.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.stateName}
                      </option>
                    ))}
                  </SelectBox>
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3">
                  <SelectBox
                    Label="City"
                    name={"cityID"}
                    validationRules={{ required: "City is required" }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  >
                    <option value={""} selected>
                      Select City
                    </option>
                    {city?.items.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.cityName}
                      </option>
                    ))}
                  </SelectBox>
                </Form.Group>
              </div>
              <p>Add Admin Detail</p>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="First Name"
                    name={"firstName"}
                    Placeholder="First Name"
                    validationRules={{
                      required: "First Name is required",
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Last Name"
                    name={"lastName"}
                    Placeholder="Last Name"
                    validationRules=""
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Email"
                    name={"useremail"}
                    Placeholder="Email"
                    validationRules={{
                      required: "Email is required",
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
              <div className="col-md-3">
                <Form.Group className="mb-3">
                  <Textbox
                    Label="Mobile Number"
                    name={"userMobile"}
                    Placeholder="Mobile"
                    validationRules={{
                      required: "Mobile Number is required",
                    }}
                    register={register}
                    errors={errors}
                    watch={watch}
                  />
                </Form.Group>
              </div>
            </div>
            <div className="text-end">
              <Button
                type="Button"
                className="me-2"
                variant="outline-danger"
                onClick={() => setShowModel(false)}
              >
                Close
              </Button>
              <Button
                type="submit"
                className=""
                disabled={isSubmitting}
                variant="success"
              >
                Save Changes
              </Button>
            </div>
          </Form>
        </FormProvider>
      </Model>

      <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex">
              <Button
                variant=""
                style={{ width: 30, height: 30, outline: "none" }}
                onClick={() => navigate(-1)}
                className="btn-sm rounded-circle"
              >
                {<FontAwesomeIcon icon={faArrowLeft} />}
              </Button>
              <h4 className="mb-0 ms-3">Company Details</h4>
            </div>
          </div>
        </div>
      </div>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="">
          <div className="d-flex">
            {/* <div>
              {dataLoading ? (
                <Skeleton height={60} width={60} />
              ) : (
                <Avatar
                  className="border p-1"
                  src={data?.icon}
                  variant="circle"
                  sx={{ width: 60, height: 60 }}
                />
              )}
            </div> */}
            <div className="ms-3 w-100">
              <div className=" w-100 pb-2">
                <h5>
                  {dataLoading ? (
                    <Skeleton height={30} width={200} />
                  ) : (
                    data?.companyName
                  )}{" "}
                </h5>
                <div className="d-flex align-items-center pb-1">
                  <div className="me-5 d-flex align-items-center">
                    {dataLoading ? (
                      <Skeleton height={20} width={200} />
                    ) : (
                      <>
                        <strong style={{ fontSize: 16 }}>Reg. Number-</strong>
                        <span>
                          {data?.transportRegNumber || "Not Available"}
                        </span>
                      </>
                    )}
                  </div>
                </div>
                <div className="d-flex align-items-center pb-1">
                  <div className="me-5 d-flex align-items-center">
                    {dataLoading ? (
                      <Skeleton height={20} width={200} />
                    ) : (
                      <>
                        <strong style={{ fontSize: 16 }}>Jurisdiction-</strong>
                        <span>{data?.jurisdiction}</span>
                      </>
                    )}
                  </div>
                </div>
                <div className="d-flex align-items-center pb-1">
                  <div className="me-5 d-flex align-items-center">
                    {dataLoading ? (
                      <Skeleton height={20} width={200} />
                    ) : (
                      <>
                        <strong style={{ fontSize: 16 }}>GST-</strong>
                        <span>{data?.gstNumber}</span>
                      </>
                    )}
                  </div>
                </div>
                <div className="d-flex align-items-center pb-1">
                  <div className="me-5 d-flex align-items-center">
                    {dataLoading ? (
                      <Skeleton height={20} width={200} />
                    ) : (
                      <>
                        <strong style={{ fontSize: 16 }}>PAN-</strong>
                        <span>{data?.panNumber}</span>
                      </>
                    )}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="me-5 d-flex align-items-center">
                    {dataLoading ? (
                      <Skeleton height={20} width={200} />
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faMobile} className="me-2" />
                        <span>{data?.mobile || "Not Available"}</span>
                      </>
                    )}
                  </div>
                  <div className="me-5 d-flex align-items-center">
                    {dataLoading ? (
                      <Skeleton height={20} width={200} />
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                        <span>{data?.email || "Not Available"}</span>
                      </>
                    )}
                  </div>
                  <div className="me-5 d-flex align-items-center">
                    {dataLoading ? (
                      <Skeleton height={20} width={200} />
                    ) : (
                      <>
                        <FontAwesomeIcon
                          icon={faInternetExplorer}
                          className="me-2"
                        />
                        <span>{data?.website || "Not Available"}</span>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Button
                onClick={() => setShowCompanyEditModel(true)}
                variant="primary"
                className="btn-sm d-inline-flex align-items-center"
              >
                <FontAwesomeIcon icon={faEdit} className="me-1" />
                Edit
              </Button>
            </div>
          </div>
          <h5 className="ms-3 mt-3">Bank Details :</h5>
          <div className="ms-3">
            <div className="d-flex align-items-center pb-1">
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>Bank Name -</strong>
                    <span>{data?.bankName}</span>
                  </>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center pb-1">
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>A/C Number -</strong>
                    <span>{data?.accountNumber}</span>
                  </>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center pb-1">
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>Account Holder Name -</strong>
                    <span>{data?.accountHolderName}</span>
                  </>
                )}
              </div>
            </div>
            <div className="d-flex align-items-center pb-1">
              <div className="me-5 d-flex align-items-center">
                {dataLoading ? (
                  <Skeleton height={20} width={200} />
                ) : (
                  <>
                    <strong style={{ fontSize: 16 }}>IFS Code -</strong>
                    <span>{data?.ifsc}</span>
                  </>
                )}
              </div>
            </div>
          </div>
          <div>
            <SignatureUploader imageURL={data?.sign} onUploaded={saveSignToDB}/>
          </div>
        </Card.Body>
      </Card>

      <Card border="light" className="shadow-sm mb-4">
        <Card.Body className="py-3">
          <div className="d-flex justify-content-between">
            <h6 className="pb-2 mb-3">Branches : </h6>
            <div>
              <Button
                variant="primary"
                style={{ outline: "none" }}
                onClick={() => setShowModel(true)}
                className="btn-sm rounded-circle"
              >
                <FontAwesomeIcon icon={faPlus} className="me-2" />
                Add New Branch
              </Button>
            </div>
          </div>
          {brachLoading ? (
            <div className="text-center my-3">
              <span
                className="spinner-border text-primary"
                role="status"
              ></span>
            </div>
          ) : (
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-0 text-center">#</th>
                  <th className="border-0 text-center">Branch Code</th>
                  <th className="border-0 text-center">Branch Name</th>
                  <th className="border-0 text-center">Address</th>
                  <th className="border-0 text-end pe-4">Action</th>
                </tr>
              </thead>
              <tbody>
                {branches?.items?.length > 0 ? (
                  branches?.items.map((item, index) => (
                    <tr key={index}>
                      <td className="text-center align-middle">
                        {(branches.pageNo - 1) * branches.pageSize + index + 1}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.branchCode || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {item.branchTitle || "-"}
                      </td>
                      <td className="fw-bold align-middle text-center">
                        {`${item.address}, ${item.cityName}, ${item.stateName}` ||
                          "-"}
                      </td>
                      <td className="text-end align-middle">
                        <Button
                          variant="primary"
                          className="btn-sm"
                          onClick={() => handleView(item.id)}
                        >
                          View Details
                        </Button>
                        {/* <Button onClick={handleDelete} variant="danger" className="btn-sm">Remove</Button> */}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
          <div className="d-flex justify-content-end">
            <CustomPagination
              totalPages={branches.totalPage}
              loading={brachLoading}
              onPageChange={handlePageChange}
            />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
